import { notifications } from "@mantine/notifications";


class Notification {
  errorNotification = (text: any) => {
    const payload = typeof text === "string" ? text : JSON.stringify(text);
    notifications.show({
      // title: payload
      message: payload,
      color: 'red',
      autoClose: 10000,
      withCloseButton: true,
    })
  };
  successNotification = (text: string | React.ReactNode, loading?: boolean, autoClose?: number) => {
    notifications.show({
      top: '70px',
      // title: payload
      message: text,
      color: undefined,
      autoClose: autoClose || 5000,
      withCloseButton: true,
      loading,
    })
  };
}

export const NOTIFICATION_SERVICE = new Notification();
